import { ILegacyPremadeBlocks } from "types/Premadeblocks/IPremadeBlocks";

export default {
  headers: [
    {
      img: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/header-01-b.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "18px 26px 18px 26px",
            "mj-class": "section",
            "background-color": "#000000",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333333333336%",
                "vertical-align": "top",
              },
              children: [
                {
                  uid: "iIj41wA5J",
                  tagName: "mj-social",
                  attributes: {
                    padding: "8px 0px 8px 0px",
                    "text-mode": "false",
                    "icon-size": "20px",
                    align: "left",
                    containerWidth: 198,
                    "icon-padding": "0px",
                  },
                  children: [
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/facebook.png",
                        name: "facebook-noshare",
                        alt: "Facebook",
                        href: "https://www.facebook.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/instagram.png",
                        alt: "Instagram",
                        name: "instagram",
                        href: "https://www.instagram.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/linkedin.png",
                        name: "linkedin-noshare",
                        alt: "LinkedIn",
                        href: "https://www.linkedin.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                  ],
                  style: "roundedwhite",
                },
              ],
              uid: "HJQ8ytZzW",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333333333336%",
                "vertical-align": "top",
              },
              children: [
                {
                  uid: "HjVSWnUJ2",
                  tagName: "mj-image",
                  attributes: {
                    src: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/logotype-dark.png",
                    padding: "0px 0px 0px 0px",
                    "fluid-on-mobile": "false",
                    alt: "",
                    href: "",
                    containerWidth: 198,
                    width: 137,
                  },
                },
              ],
              uid: "CZCiVMqJr",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333333333336%",
                "vertical-align": "top",
              },
              children: [
                {
                  uid: "lAW3ocN-9",
                  tagName: "mj-spacer",
                  attributes: {
                    height: "30.390625px",
                    containerWidth: 198,
                  },
                },
              ],
              uid: "vcQe-KL02u",
            },
          ],
          layout: 1,
          backgroundColor: null,
          backgroundImage: null,
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "Byggju-zb",
        },
      ],
    },
    {
      img: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/header-01-w.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "18px 26px 18px 26px",
            "mj-class": "section",
            "background-color": "#FFFFFF",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333333333336%",
                "vertical-align": "top",
              },
              children: [
                {
                  uid: "XCmGOVWD-x",
                  tagName: "mj-social",
                  attributes: {
                    padding: "8px 0px 8px 0px",
                    "text-mode": "false",
                    "icon-size": "20px",
                    align: "left",
                    containerWidth: 198,
                    "icon-padding": "0px",
                  },
                  children: [
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/facebook.png",
                        name: "facebook-noshare",
                        alt: "Facebook",
                        href: "https://www.facebook.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/instagram.png",
                        alt: "Instagram",
                        name: "instagram",
                        href: "https://www.instagram.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/linkedin.png",
                        name: "linkedin-noshare",
                        alt: "LinkedIn",
                        href: "https://www.linkedin.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                  ],
                  style: "ikony-black/roundedblack",
                },
              ],
              uid: "HJQ8ytZzW",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333333333336%",
                "vertical-align": "top",
              },
              children: [
                {
                  uid: "WSTls9PtBU",
                  tagName: "mj-image",
                  attributes: {
                    src: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/logotype-light.png",
                    padding: "0px 0px 0px 0px",
                    "fluid-on-mobile": "false",
                    alt: "",
                    href: "",
                    containerWidth: 198,
                    width: 137,
                  },
                },
              ],
              uid: "CZCiVMqJr",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333333333336%",
                "vertical-align": "top",
              },
              children: [
                {
                  uid: "GF7OGJs-Dl",
                  tagName: "mj-spacer",
                  attributes: {
                    height: "25.4765625px",
                    containerWidth: 198,
                  },
                },
              ],
              uid: "vcQe-KL02u",
            },
          ],
          layout: 1,
          backgroundColor: null,
          backgroundImage: null,
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "DAPbw6xdT",
        },
      ],
    },
    {
      img: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/header-02-b.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "18px 26px 18px 26px",
            "mj-class": "section",
            "background-color": "#000000",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333333333336%",
                "vertical-align": "top",
              },
              children: [
                {
                  uid: "O1UdHaHnL",
                  tagName: "mj-spacer",
                  attributes: {
                    height: "30.390625px",
                    containerWidth: 198,
                  },
                },
              ],
              uid: "HJQ8ytZzW",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333333333336%",
                "vertical-align": "top",
              },
              children: [
                {
                  uid: "BT5BlMvznB",
                  tagName: "mj-image",
                  attributes: {
                    src: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/logotype-dark.png",
                    padding: "0px 0px 0px 0px",
                    "fluid-on-mobile": "false",
                    alt: "",
                    href: "",
                    containerWidth: 198,
                    width: 137,
                  },
                },
              ],
              uid: "CZCiVMqJr",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333333333336%",
                "vertical-align": "top",
              },
              children: [
                {
                  uid: "14Oa7Un_T",
                  tagName: "mj-social",
                  attributes: {
                    padding: "8px 0px 8px 0px",
                    "text-mode": "false",
                    "icon-size": "20px",
                    align: "right",
                    containerWidth: 198,
                    "icon-padding": "0px",
                  },
                  children: [
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/facebook.png",
                        name: "facebook-noshare",
                        alt: "Facebook",
                        href: "https://www.facebook.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/instagram.png",
                        alt: "Instagram",
                        name: "instagram",
                        href: "https://www.instagram.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/linkedin.png",
                        name: "linkedin-noshare",
                        alt: "LinkedIn",
                        href: "https://www.linkedin.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                  ],
                  style: "roundedwhite",
                },
              ],
              uid: "vcQe-KL02u",
            },
          ],
          layout: 1,
          backgroundColor: null,
          backgroundImage: null,
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "P2fM6_fcp",
        },
      ],
    },
    {
      img: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/header-02-w.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "18px 26px 18px 26px",
            "mj-class": "section",
            "background-color": "#FFFFFF",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333333333336%",
                "vertical-align": "top",
              },
              children: [
                {
                  uid: "NDdSwfFWkI",
                  tagName: "mj-spacer",
                  attributes: {
                    height: "30.390625px",
                    containerWidth: 198,
                  },
                },
              ],
              uid: "HJQ8ytZzW",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333333333336%",
                "vertical-align": "top",
              },
              children: [
                {
                  uid: "F-9tk_VLc-",
                  tagName: "mj-image",
                  attributes: {
                    src: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/logotype-light.png",
                    padding: "0px 0px 0px 0px",
                    "fluid-on-mobile": "false",
                    alt: "",
                    href: "",
                    containerWidth: 198,
                    width: 137,
                  },
                },
              ],
              uid: "CZCiVMqJr",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333333333336%",
                "vertical-align": "top",
              },
              children: [
                {
                  uid: "1VkspOlNx2",
                  tagName: "mj-social",
                  attributes: {
                    padding: "8px 0px 8px 0px",
                    "text-mode": "false",
                    "icon-size": "20px",
                    align: "right",
                    containerWidth: 198,
                    "icon-padding": "0px",
                  },
                  children: [
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/facebook.png",
                        name: "facebook-noshare",
                        alt: "Facebook",
                        href: "https://www.facebook.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/instagram.png",
                        alt: "Instagram",
                        name: "instagram",
                        href: "https://www.instagram.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/linkedin.png",
                        name: "linkedin-noshare",
                        alt: "LinkedIn",
                        href: "https://www.linkedin.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                  ],
                  style: "ikony-black/roundedblack",
                },
              ],
              uid: "vcQe-KL02u",
            },
          ],
          layout: 1,
          backgroundColor: null,
          backgroundImage: null,
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "jCfZtUdwS",
        },
      ],
    },
    {
      img: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/header-03-b.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "18px 26px 18px 26px",
            "mj-class": "section",
            "background-color": "#000000",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  uid: "lEaUr5yS3",
                  tagName: "mj-image",
                  attributes: {
                    src: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/logotype-dark.png",
                    padding: "0px 0px 0px 4px",
                    "fluid-on-mobile": "false",
                    alt: "",
                    href: "",
                    containerWidth: 300,
                    width: 137,
                    align: "left",
                  },
                },
              ],
              uid: "HJQ8ytZzW",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  uid: "EpuUv31U4",
                  tagName: "mj-social",
                  attributes: {
                    padding: "8px 0px 8px 0px",
                    "text-mode": "false",
                    "icon-size": "20px",
                    align: "right",
                    containerWidth: 198,
                    "icon-padding": "0px",
                  },
                  children: [
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/facebook.png",
                        name: "facebook-noshare",
                        alt: "Facebook",
                        href: "https://www.facebook.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/instagram.png",
                        alt: "Instagram",
                        name: "instagram",
                        href: "https://www.instagram.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/roundedwhite/linkedin.png",
                        name: "linkedin-noshare",
                        alt: "LinkedIn",
                        href: "https://www.linkedin.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                  ],
                  style: "roundedwhite",
                },
              ],
              uid: "CZCiVMqJr",
            },
          ],
          layout: 1,
          backgroundColor: null,
          backgroundImage: null,
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "TKldf9uW2",
        },
      ],
    },
    {
      img: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/header-03-w.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "18px 26px 18px 26px",
            "mj-class": "section",
            "background-color": "#FFFFFF",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  uid: "VyZollMlhQ",
                  tagName: "mj-image",
                  attributes: {
                    src: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/logotype-light.png",
                    padding: "0px 0px 0px 4px",
                    "fluid-on-mobile": "false",
                    alt: "",
                    href: "",
                    containerWidth: 300,
                    width: 137,
                    align: "left",
                  },
                },
              ],
              uid: "HJQ8ytZzW",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  uid: "x182W-UQj6",
                  tagName: "mj-social",
                  attributes: {
                    padding: "8px 0px 8px 0px",
                    "text-mode": "false",
                    "icon-size": "20px",
                    align: "right",
                    containerWidth: 198,
                    "icon-padding": "0px",
                  },
                  children: [
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/facebook.png",
                        name: "facebook-noshare",
                        alt: "Facebook",
                        href: "https://www.facebook.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/instagram.png",
                        alt: "Instagram",
                        name: "instagram",
                        href: "https://www.instagram.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                    {
                      tagName: "mj-social-element",
                      attributes: {
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/ikony-black/roundedblack/linkedin.png",
                        name: "linkedin-noshare",
                        alt: "LinkedIn",
                        href: "https://www.linkedin.com/PROFILE",
                        "background-color": "transparent",
                        show: true,
                      },
                    },
                  ],
                  style: "ikony-black/roundedblack",
                },
              ],
              uid: "CZCiVMqJr",
            },
          ],
          layout: 1,
          backgroundColor: null,
          backgroundImage: null,
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "fu7paBzJS",
        },
      ],
    },
    {
      img: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/header-04-b.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "18px 30px 18px 30px",
            "background-color": "#000000",
            "mj-class": "section",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "40%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/logotype-dark.png",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 200,
                    width: 137,
                    widthPercent: 50,
                    align: "left",
                  },
                  uid: "eWHB7alFd",
                },
              ],
              uid: "Sk4UH-rlm",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "60%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "right",
                    "font-size": "11px",
                    padding: "10px 0px 10px 0px",
                    containerWidth: 300,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                    color: "#FFFFFF",
                    "line-height": 2,
                  },
                  uid: "WR8OFfrzO9",
                  content:
                    '<p style="text-align: right;"><span style="font-size: 12px; font-family: Roboto, Tahoma, sans-serif; font-weight: medium;">Menu Item        Menu Item        Menu Item        Menu Item</span></p>',
                },
              ],
              uid: "rklE8Bbre7",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "G3qDn4kAPa",
        },
      ],
    },
    {
      img: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/header-04-w.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "18px 30px 18px 30px",
            "background-color": "#FFFFFF",
            "mj-class": "section",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "40%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/logotype-light.png",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 200,
                    width: 137,
                    widthPercent: 50,
                    align: "left",
                  },
                  uid: "i_y_SIic6n",
                },
              ],
              uid: "Sk4UH-rlm",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "60%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "right",
                    "font-size": "11px",
                    padding: "10px 0px 10px 0px",
                    containerWidth: 300,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                    color: "#FFFFFF",
                    "line-height": 2,
                  },
                  uid: "8DxeMnnKDK",
                  content:
                    '<p style="text-align: right;"><span style="color: rgb(0, 0, 0);"><span style="font-size: 12px; font-family: Roboto, Tahoma, sans-serif;">Menu Item        Menu Item        Menu Item        Menu Item</span></span></p>',
                },
              ],
              uid: "rklE8Bbre7",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "cEPM_EllA",
        },
      ],
    },
    {
      img: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/header-05-b.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 0px 12px 0px",
            "background-color": "#000000",
            "mj-class": "section",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "100%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/logotype-dark.png",
                    padding: "0px 0px 1px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 600,
                    width: "137",
                    widthPercent: 18,
                  },
                  uid: "kMjJo9fRx",
                },
                {
                  tagName: "mj-divider",
                  attributes: {
                    "border-color": "#73737D",
                    "border-style": "solid",
                    "border-width": "1px",
                    padding: "10px 100px",
                    containerWidth: 600,
                    "padding-top": "10px",
                    "padding-bottom": "10px",
                  },
                  uid: "zuFzLIGUtP",
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "0px 0px 0px 0px",
                    color: "#FFFFFF",
                    containerWidth: 600,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                    "line-height": 2,
                  },
                  uid: "QELtTvNTBc",
                  content:
                    '<p><span style="font-size: 12px; font-family: Roboto, Tahoma, sans-serif;">Menu Item              Menu Item              Menu Item              Menu Item</span></p>',
                },
              ],
              uid: "SJBgnUCmVx7",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "owVy92DiRd",
        },
      ],
    },
    {
      img: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/header-05-w.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 0px 12px 0px",
            "background-color": "#FFFFFF",
            "mj-class": "section",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "100%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://topolio.s3.eu-west-1.amazonaws.com/assets/premade-blocks/logotype-light.png",
                    padding: "0px 0px 1px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 600,
                    width: "137",
                    widthPercent: 18,
                  },
                  uid: "zXaHkMbMde",
                },
                {
                  tagName: "mj-divider",
                  attributes: {
                    "border-color": "#73737D",
                    "border-style": "solid",
                    "border-width": "1px",
                    padding: "10px 100px",
                    containerWidth: 600,
                    "padding-top": "10px",
                    "padding-bottom": "10px",
                  },
                  uid: "GM5v-BAiN9",
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "0px 0px 0px 0px",
                    color: "#FFFFFF",
                    containerWidth: 600,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                    "line-height": 2,
                  },
                  uid: "0VUcRtHwBx",
                  content:
                    '<p><span style="color: rgb(0, 0, 0);"><span style="font-size: 12px; font-family: Roboto, Tahoma, sans-serif;">Menu Item              Menu Item              Menu Item              Menu Item</span></span></p>',
                },
              ],
              uid: "SJBgnUCmVx7",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "NlLOq6Xfy",
        },
      ],
    },
  ],
  content: [
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/content/content1.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "19px 0px 19px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "25%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/logo-yahoo.jpg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 150,
                    width: 98,
                    widthPercent: 65,
                  },
                  uid: "HkgZabvExQ",
                },
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/logo-microsoft.jpg",
                    padding: "20px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 150,
                    width: 95,
                    widthPercent: 63,
                  },
                  uid: "BJWb6ZvNlX",
                },
              ],
              uid: "H1sG1vNem",
            },
            {
              tagName: "mj-column",
              attributes: { width: "25%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/logo-amazon.jpg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 150,
                    width: 78,
                    widthPercent: 52,
                  },
                  uid: "HJGbaZPNem",
                },
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/logo-jl.jpg",
                    padding: "20px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 150,
                    width: 95,
                    widthPercent: 63,
                  },
                  uid: "H1X-pWDExm",
                },
              ],
              uid: "H1sG1vNem",
            },
            {
              tagName: "mj-column",
              attributes: { width: "25%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/logo-nintendo.jpg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 150,
                    width: 80,
                    widthPercent: 53,
                  },
                  uid: "BkV-pbw4x7",
                },
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/logo-goole.jpg",
                    padding: "20px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 150,
                    width: 80,
                    widthPercent: 53,
                  },
                  uid: "SJBb6-wEe7",
                },
              ],
              uid: "H1sG1vNem",
            },
            {
              tagName: "mj-column",
              attributes: { width: "25%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/logo-blackberry.jpg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 150,
                    width: 102,
                    widthPercent: 68,
                  },
                  uid: "By8WTbv4lQ",
                },
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/logo-yahoo.jpg",
                    padding: "20px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 150,
                    width: 98,
                    widthPercent: 65,
                  },
                  uid: "rkDbpWwEx7",
                },
              ],
              uid: "H1sG1vNem",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "SyWTZv4gm",
        },
      ],
    },
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/content/content2.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "19px 0px 19px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333333333336%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/logo-yahoo.jpg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 200,
                    width: 98,
                    widthPercent: 65,
                  },
                  uid: "H1Lsbw4lm",
                },
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/logo-microsoft.jpg",
                    padding: "20px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 200,
                    width: 95,
                    widthPercent: 63,
                  },
                  uid: "rJ3G-vEx7",
                },
              ],
              uid: "H1sG1vNem",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333333333336%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/logo-amazon.jpg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 200,
                    width: 78,
                    widthPercent: 52,
                  },
                  uid: "SyGz7kvEg7",
                },
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/logo-jl.jpg",
                    padding: "20px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 200,
                    width: 95,
                    widthPercent: 63,
                  },
                  uid: "S1JQbwElX",
                },
              ],
              uid: "H1sG1vNem",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333333333336%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/logo-nintendo.jpg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 200,
                    width: 80,
                    widthPercent: 53,
                  },
                  uid: "B14fm1vVgQ",
                },
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/logo-goole.jpg",
                    padding: "20px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 200,
                    width: 80,
                    widthPercent: 53,
                  },
                  uid: "Bk7XZvVgm",
                },
              ],
              uid: "H1sG1vNem",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "rkzXyDVlm",
        },
      ],
    },
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/content/content3.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "9px 0px 9px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "33.333333%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-spacer",
                  attributes: { height: 50, containerWidth: 200 },
                  uid: "HkgVWvvNeX",
                },
              ],
              uid: "SJi2QDElm",
            },
            {
              tagName: "mj-column",
              attributes: { width: "33.333333%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "2px 2px 2px 2px",
                    containerWidth: 200,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                  },
                  uid: "ry-V-vPNgX",
                  content:
                    '<p><strong><span style="font-size:18px;">Top Stories</span></strong></p>\n',
                },
              ],
              uid: "Sygo3QwEgQ",
            },
            {
              tagName: "mj-column",
              attributes: { width: "33.333333%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-button",
                  attributes: {
                    align: "right",
                    border: "1px solid #7E7E7E",
                    "background-color": "#FFFFFF",
                    color: "#45414e",
                    "border-radius": "24px",
                    "font-size": "11px",
                    padding: "13px 31px 13px 31px",
                    href: "https://google.com",
                    "font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    containerWidth: 200,
                    "inner-padding": "7px 20px",
                  },
                  content: "All articles",
                  uid: "Byz4-wDNgX",
                },
              ],
              uid: "Hybi37vVlQ",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "SkNWvwNgQ",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "9px 0px 9px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "50%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/pexels-photo-842947.jpeg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 300,
                    width: 240,
                    widthPercent: 80,
                  },
                  uid: "BkxpF_PNlQ",
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "10px 35px 0px 35px",
                    containerWidth: 300,
                  },
                  uid: "S1ZaFOwVe7",
                  content:
                    '<p><strong><span style="color:#27ae60;">November 12</span></strong></p>\n',
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 35px 20px 35px",
                    containerWidth: 300,
                  },
                  uid: "rJM6tdDEgX",
                  content:
                    '<h2 style="margin-top: 0">Lorem ipsum dolor sit amet</h2>\n\n<p><span style="color:#999999;"><span style="font-size:14px;">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed ac dolor sit amet purus</span></span></p>\n',
                },
              ],
              uid: "ByzinXPVgX",
            },
            {
              tagName: "mj-column",
              attributes: { width: "50%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/pexels-photo-1118179.jpeg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 300,
                    width: 243,
                    widthPercent: 81,
                  },
                  uid: "SkX6tOw4eX",
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "10px 35px 0px 35px",
                    containerWidth: 300,
                  },
                  uid: "HJ4ptdD4eX",
                  content:
                    '<p><strong><span style="color:#27ae60;">November 12</span></strong></p>\n',
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 35px 20px 35px",
                    containerWidth: 300,
                  },
                  uid: "ByBpt_PNlQ",
                  content:
                    '<h2 style="margin-top: 0">Lorem ipsum dolor sit amet</h2>\n\n<p><span style="color:#999999;"><span style="font-size:14px;">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed ac dolor sit amet purus</span></span></p>\n',
                },
              ],
              uid: "SkQonmwVeX",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "rkaY_w4l7",
        },
      ],
    },
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/content/content4.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "9px 0px 9px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-spacer",
                  attributes: {
                    height: 50,
                    containerWidth: 200,
                  },
                  uid: "SJeVt_PVxm",
                },
              ],
              uid: "SJi2QDElm",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "2px 2px 2px 2px",
                    containerWidth: 200,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                  },
                  uid: "r1-Etdv4gQ",
                  content:
                    '<p><strong><span style="font-size:18px;">Top Stories</span></strong></p>\n',
                },
              ],
              uid: "Sygo3QwEgQ",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "33.333333%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-button",
                  attributes: {
                    align: "right",
                    border: "1px solid #7E7E7E",
                    "background-color": "#FFFFFF",
                    color: "#45414e",
                    "border-radius": "24px",
                    "font-size": "11px",
                    padding: "13px 31px 13px 31px",
                    href: "https://google.com",
                    "font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    containerWidth: 200,
                    "inner-padding": "7px 20px",
                  },
                  content: "All articles",
                  uid: "HyMVF_vVx7",
                },
              ],
              uid: "Hybi37vVlQ",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "SyNKODVlm",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "9px 0px 9px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/pexels-photo-842947.jpeg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 300,
                    width: 240,
                    widthPercent: 80,
                  },
                  uid: "Skxd9ODExX",
                },
              ],
              uid: "ByzinXPVgX",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "10px 35px 0px 0px",
                    containerWidth: 300,
                  },
                  uid: "HJ2qOwEeX",
                  content:
                    '<p><strong><span style="color:#27ae60;">November 12</span></strong></p>\n',
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 35px 20px 0px",
                    containerWidth: 300,
                  },
                  uid: "HyJoOvNxX",
                  content:
                    '<h2 style="margin-top: 0">Lorem ipsum dolor sit amet</h2>\n\n<p><span style="color:#999999;"><span style="font-size:14px;">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed ac dolor sit amet purus</span></span></p>\n',
                },
              ],
              uid: "SkQonmwVeX",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "B1O9dDNgm",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "9px 0px 9px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/pexels-photo-1118179.jpeg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 300,
                    width: 243,
                    widthPercent: 81,
                  },
                  uid: "ryHiuPElQ",
                },
              ],
              uid: "ByzinXPVgX",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "10px 35px 0px 0px",
                    containerWidth: 300,
                  },
                  uid: "BkVrWwwEem",
                  content:
                    '<p><strong><span style="color:#27ae60;">November 12</span></strong></p>\n',
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 35px 20px 0px",
                    containerWidth: 300,
                  },
                  uid: "BJrBWwPNxX",
                  content:
                    '<h2 style="margin-top: 0">Lorem ipsum dolor sit amet</h2>\n\n<p><span style="color:#999999;"><span style="font-size:14px;">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed ac dolor sit amet purus</span></span></p>\n',
                },
              ],
              uid: "SkQonmwVeX",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "S1rWvPNlQ",
        },
      ],
    },
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/content/content5.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "9px 0px 9px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "33.333333%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-spacer",
                  attributes: { height: 50, containerWidth: 200 },
                  uid: "rylYEwPEem",
                },
              ],
              uid: "SJi2QDElm",
            },
            {
              tagName: "mj-column",
              attributes: { width: "33.333333%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "2px 2px 2px 2px",
                    containerWidth: 200,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                  },
                  uid: "rk-Y4vwExm",
                  content:
                    '<p><strong><span style="font-size:18px;">Top Stories</span></strong></p>\n',
                },
              ],
              uid: "Sygo3QwEgQ",
            },
            {
              tagName: "mj-column",
              attributes: { width: "33.333333%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-button",
                  attributes: {
                    align: "right",
                    border: "1px solid #7E7E7E",
                    "background-color": "#FFFFFF",
                    color: "#45414e",
                    "border-radius": "24px",
                    "font-size": "11px",
                    padding: "13px 31px 13px 31px",
                    href: "https://google.com",
                    "font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    containerWidth: 200,
                    "inner-padding": "7px 20px",
                  },
                  content: "All articles",
                  uid: "ByGK4PvExX",
                },
              ],
              uid: "Hybi37vVlQ",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "BytNvv4lQ",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "9px 0px 9px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "50%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/pexels-photo-842947.jpeg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 300,
                    width: 240,
                    widthPercent: 80,
                  },
                  uid: "B1g2EvvVxQ",
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "10px 20px 0px 20px",
                    containerWidth: 300,
                  },
                  uid: "HkWhEvDNeQ",
                  content:
                    '<p><strong><span style="color:#27ae60;">November 12</span></strong></p>\n',
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "0px 35px 20px 35px",
                    containerWidth: 300,
                  },
                  uid: "SJUv_wEeQ",
                  content:
                    '<h2 style="margin-top: 0">Lorem ipsum dolor sit amet</h2>\n\n<p><span style="color:#999999;"><span style="font-size:14px;">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed ac dolor sit amet purus</span></span></p>\n',
                },
              ],
              uid: "ByzinXPVgX",
            },
            {
              tagName: "mj-column",
              attributes: { width: "50%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/pexels-photo-1118179.jpeg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 300,
                    width: 243,
                    widthPercent: 81,
                  },
                  uid: "BJmhEwvNeQ",
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "10px 20px 0px 20px",
                    containerWidth: 300,
                  },
                  uid: "HyV3NwvVxm",
                  content:
                    '<p><strong><span style="color:#27ae60;">November 12</span></strong></p>\n',
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "0px 35px 20px 35px",
                    containerWidth: 300,
                  },
                  uid: "B1B3EvPVgQ",
                  content:
                    '<h2 style="margin-top: 0">Lorem ipsum dolor sit amet</h2>\n\n<p><span style="color:#999999;"><span style="font-size:14px;">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed ac dolor sit amet purus</span></span></p>\n',
                },
              ],
              uid: "SkQonmwVeX",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "Bk2VPvNeQ",
        },
      ],
    },
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/content/content6.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "9px 0px 9px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "33.333333%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-spacer",
                  attributes: { height: 50, containerWidth: 200 },
                  uid: "r1gJLODVem",
                },
              ],
              uid: "SJi2QDElm",
            },
            {
              tagName: "mj-column",
              attributes: { width: "33.333333%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "2px 2px 2px 2px",
                    containerWidth: 200,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                  },
                  uid: "HkZkI_wVlX",
                  content:
                    '<p><strong><span style="font-size:18px;">Top Stories</span></strong></p>\n',
                },
              ],
              uid: "Sygo3QwEgQ",
            },
            {
              tagName: "mj-column",
              attributes: { width: "33.333333%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-button",
                  attributes: {
                    align: "right",
                    border: "1px solid #7E7E7E",
                    "background-color": "#FFFFFF",
                    color: "#45414e",
                    "border-radius": "24px",
                    "font-size": "11px",
                    padding: "13px 31px 13px 31px",
                    href: "https://google.com",
                    "font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    containerWidth: 200,
                    "inner-padding": "7px 20px",
                  },
                  content: "All articles",
                  uid: "rJG18dvVx7",
                },
              ],
              uid: "Hybi37vVlQ",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "B1JI_w4g7",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "0px 0px 0px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/pexels-photo-842947.jpeg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 600,
                    width: 528,
                    widthPercent: 88,
                  },
                  uid: "HJlQLOvExX",
                },
              ],
              uid: "ByzinXPVgX",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "SyQIdwNem",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "0px 0px 0px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "10px 35px 0px 35px",
                    containerWidth: 600,
                  },
                  uid: "HkgOLOv4xm",
                  content:
                    '<p><strong><span style="color:#27ae60;">November 12</span></strong></p>\n',
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 35px 20px 35px",
                    containerWidth: 300,
                  },
                  uid: "Sy5PuDVlX",
                  content:
                    '<h2 style="margin-top: 0">Lorem ipsum dolor sit amet</h2>\n\n<p><span style="color:#999999;"><span style="font-size:14px;">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed ac dolor sit amet purus</span></span></p>\n',
                },
              ],
              uid: "SJratbSxQ",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "HJOUOv4g7",
        },
      ],
    },
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/content/content7.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "9px 0px 9px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "33.333333%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-spacer",
                  attributes: { height: 50, containerWidth: 200 },
                  uid: "Hk5ezDVgm",
                },
              ],
              uid: "SJi2QDElm",
            },
            {
              tagName: "mj-column",
              attributes: { width: "33.333333%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "2px 2px 2px 2px",
                    containerWidth: 200,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                  },
                  uid: "Bk9C-wNxQ",
                  content:
                    '<p><strong><span style="font-size:18px;">Top Stories</span></strong></p>\n',
                },
              ],
              uid: "Sygo3QwEgQ",
            },
            {
              tagName: "mj-column",
              attributes: { width: "33.333333%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-button",
                  attributes: {
                    align: "right",
                    border: "1px solid #7E7E7E",
                    "background-color": "#FFFFFF",
                    color: "#45414e",
                    "border-radius": "24px",
                    "font-size": "11px",
                    padding: "13px 31px 13px 31px",
                    href: "https://google.com",
                    "font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    containerWidth: 200,
                    "inner-padding": "7px 20px",
                  },
                  content: "All articles",
                  uid: "BkaezwVg7",
                },
              ],
              uid: "Hybi37vVlQ",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "SyvCZDVxQ",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "0px 0px 0px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/pexels-photo-842947.jpeg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 600,
                    width: 528,
                    widthPercent: 88,
                  },
                  uid: "rkvSzDNeX",
                },
              ],
              uid: "ByzinXPVgX",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "Bk4HzDVxX",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "0px 0px 0px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "50%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "10px 35px 0px 35px",
                    containerWidth: 600,
                  },
                  uid: "SyYPwwNeX",
                  content:
                    '<p><strong><span style="color:#27ae60;">November 12</span></strong></p>\n',
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 35px 20px 35px",
                    containerWidth: 600,
                  },
                  uid: "HyluvDEg7",
                  content:
                    '<h2 style="margin-top: 0">Lorem ipsum dolor sit amet</h2>\n',
                },
              ],
              uid: "B1lBpF-BxQ",
            },
            {
              tagName: "mj-column",
              attributes: { width: "50%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-spacer",
                  attributes: { height: 38, containerWidth: 300 },
                  uid: "Byx2DP4xQ",
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 35px 20px 35px",
                    containerWidth: 600,
                  },
                  uid: "ry-dvD4e7",
                  content:
                    '<p style="margin-top: 0px;"><span style="font-size:14px;"><span style="color:#999999;">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed ac dolor sit amet purus.</span></span></p>\n',
                },
              ],
              uid: "HyWBpFWHgQ",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "rkSvPvVl7",
        },
      ],
    },
  ],
  ecomm: [
    {
      img: "https://premade-blocks.s3.eu-central-1.amazonaws.com/ecomm1en.png",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 0px 5px 0px",
            "mj-class": "section",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-feed-block",
                  uid: "TtYvd2bxh",
                  attributes: {
                    containerWidth: 600,
                    dynamic: true,
                    "columns-layout": "text-image",
                    image: "*|PRODUCT_IMG_SRC|*",
                    "image-width": 300,
                    "image-alt": "",
                    "image-title": "",
                    "image-fluid-on-mobile": "false",
                    "image-align": "center",
                    href: "*|PRODUCT_HREF|*",
                    title: "*|PRODUCT_TITLE|*",
                    "raw-title": "*|PRODUCT_TITLE|*",
                    "title-font-size": "17px",
                    "title-color": "#000000",
                    "title-font-family": "Ubuntu, Helvetica, Arial, sans-serif",
                    "title-font-weight": "bold",
                    "title-font-style": "normal",
                    "title-text-transform": "none",
                    "title-text-decoration": "none",
                    "title-padding": "10px 10px 0px 10px",
                    "title-align": "center",
                    description: "*|PRODUCT_DESC|*",
                    "raw-description": "*|PRODUCT_DESC|*",
                    "description-font-size": "14px",
                    "description-color": "#000000",
                    "description-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif",
                    "description-font-weight": "normal",
                    "description-font-style": "normal",
                    "description-text-transform": "none",
                    "description-text-decoration": "none",
                    "description-padding": "5px 10px 5px 10px",
                    "description-align": "center",
                    "price-before": "*|PRODUCT_PRICE_BEFORE|*",
                    "raw-price-before": "*|PRODUCT_PRICE_BEFORE|*",
                    "price-before-font-size": "13px",
                    "price-before-color": "#000000",
                    "price-before-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif",
                    "price-before-font-weight": "normal",
                    "price-before-font-style": "normal",
                    "price-before-text-transform": "none",
                    "price-before-text-decoration": "none",
                    "price-before-padding": "5px 10px 5px 10px",
                    "price-before-align": "center",
                    price: "*|PRODUCT_PRICE|*",
                    "raw-price": "*|PRODUCT_PRICE|*",
                    "price-font-size": "18px",
                    "price-color": "#000000",
                    "price-font-family": "Ubuntu, Helvetica, Arial, sans-serif",
                    "price-font-weight": "normal",
                    "price-font-style": "normal",
                    "price-text-transform": "none",
                    "price-text-decoration": "none",
                    "price-padding": "5px 10px 5px 10px",
                    "price-align": "center",
                    "button-align": "center",
                    "button-background-color": "#000000",
                    "button-color": "#FFFFFF",
                    "button-font-size": "13px",
                    "button-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif",
                    "button-font-weight": "normal",
                    "button-font-style": "normal",
                    "button-text-transform": "none",
                    "button-text-decoration": "none",
                    "button-border-radius": "3px",
                    "button-padding": "5px 10px 10px 10px",
                    "button-inner-padding": "10px 20px 10px 20px",
                    button: "Buy Now",
                    layout:
                      "image:show,title:show,description:show,priceBefore:show,price:show,button:show",
                    "image-padding": "10px 10px 10px 10px",
                    "button-width": "100%",
                  },
                  items: [],
                  mode: "static",
                  layout: "text-image",
                  maxPerRow: 1,
                  children: [
                    {
                      tagName: "mj-column",
                      uid: "6c0f3bbc-e5bb-49a9-b963-0eb8c38e01e7",
                      attributes: {
                        "vertical-align": "top",
                        padding: "0",
                        width: "100%",
                      },
                      children: [],
                    },
                  ],
                  blockName: "product",
                },
              ],
              uid: "jrlNPldzIp",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "xZBHTfHxV",
        },
      ],
    },
    {
      img: "https://premade-blocks.s3.eu-central-1.amazonaws.com/ecomm2en.png",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 0px 5px 0px",
            "mj-class": "section",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-feed-block",
                  uid: "iKadtmWSo1",
                  attributes: {
                    containerWidth: 600,
                    dynamic: true,
                    "columns-layout": "image-text",
                    image: "*|PRODUCT_IMG_SRC|*",
                    "image-width": 300,
                    "image-alt": "",
                    "image-title": "",
                    "image-fluid-on-mobile": "false",
                    "image-align": "center",
                    href: "*|PRODUCT_HREF|*",
                    title: "*|PRODUCT_TITLE|*",
                    "raw-title": "*|PRODUCT_TITLE|*",
                    "title-font-size": "17px",
                    "title-color": "#000000",
                    "title-font-family": "Ubuntu, Helvetica, Arial, sans-serif",
                    "title-font-weight": "bold",
                    "title-font-style": "normal",
                    "title-text-transform": "none",
                    "title-text-decoration": "none",
                    "title-padding": "10px 10px 0px 10px",
                    "title-align": "center",
                    description: "*|PRODUCT_DESC|*",
                    "raw-description": "*|PRODUCT_DESC|*",
                    "description-font-size": "14px",
                    "description-color": "#000000",
                    "description-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif",
                    "description-font-weight": "normal",
                    "description-font-style": "normal",
                    "description-text-transform": "none",
                    "description-text-decoration": "none",
                    "description-padding": "5px 10px 5px 10px",
                    "description-align": "center",
                    "price-before": "*|PRODUCT_PRICE_BEFORE|*",
                    "raw-price-before": "*|PRODUCT_PRICE_BEFORE|*",
                    "price-before-font-size": "13px",
                    "price-before-color": "#000000",
                    "price-before-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif",
                    "price-before-font-weight": "normal",
                    "price-before-font-style": "normal",
                    "price-before-text-transform": "none",
                    "price-before-text-decoration": "none",
                    "price-before-padding": "5px 10px 5px 10px",
                    "price-before-align": "center",
                    price: "*|PRODUCT_PRICE|*",
                    "raw-price": "*|PRODUCT_PRICE|*",
                    "price-font-size": "18px",
                    "price-color": "#000000",
                    "price-font-family": "Ubuntu, Helvetica, Arial, sans-serif",
                    "price-font-weight": "normal",
                    "price-font-style": "normal",
                    "price-text-transform": "none",
                    "price-text-decoration": "none",
                    "price-padding": "5px 10px 5px 10px",
                    "price-align": "center",
                    "button-align": "center",
                    "button-background-color": "#000000",
                    "button-color": "#FFFFFF",
                    "button-font-size": "13px",
                    "button-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif",
                    "button-font-weight": "normal",
                    "button-font-style": "normal",
                    "button-text-transform": "none",
                    "button-text-decoration": "none",
                    "button-border-radius": "3px",
                    "button-padding": "5px 10px 10px 10px",
                    "button-inner-padding": "10px 20px 10px 20px",
                    button: "Buy Now",
                    layout:
                      "image:show,title:show,description:show,priceBefore:show,price:show,button:show",
                    "image-padding": "10px 10px 10px 10px",
                    "button-width": "100%",
                  },
                  items: [],
                  mode: "static",
                  layout: "image-text",
                  maxPerRow: 1,
                  children: [
                    {
                      tagName: "mj-column",
                      uid: "6c0f3bbc-e5bb-49a9-b963-0eb8c38e01e7",
                      attributes: {
                        "vertical-align": "top",
                        padding: "0",
                        width: "100%",
                      },
                      children: [],
                    },
                  ],
                  blockName: "product",
                },
              ],
              uid: "jrlNPldzIp",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "CvQEdUZcz",
        },
      ],
    },
    {
      img: "https://premade-blocks.s3.eu-central-1.amazonaws.com/ecomm3en.png",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 0px 10px 0px",
            "mj-class": "section",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-button",
                  uid: "4xN9V9EFU",
                  attributes: {
                    align: "right",
                    "background-color": "#FFFFFF",
                    color: "#000000",
                    "border-radius": "24px",
                    "font-size": "12px",
                    padding: "10px 10px 10px 10px",
                    "inner-padding": "6px 18px",
                    href: "https://google.com",
                    "font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    containerWidth: 200,
                    border: "1px solid #7E7E7E",
                    "line-height": "15px",
                  },
                  content: "<div>Go to the website</div>",
                },
                {
                  tagName: "mj-text",
                  uid: "IEKKWZD9M5",
                  attributes: {
                    align: "left",
                    padding: "0px 10px 5px 10px",
                    "line-height": 1.5,
                    containerWidth: 300,
                  },
                  content: `<h1 style="margin-top: 0px; text-align: center;">Don't miss out on:</h1>`,
                },
                {
                  tagName: "mj-feed-block",
                  uid: "Mz9kSQjmEv",
                  blockName: "product",
                  attributes: {
                    "columns-layout": "one-column",
                    image: "*|PRODUCT_IMG_SRC|*",
                    "image-width": 300,
                    "image-alt": "",
                    "image-title": "",
                    "image-fluid-on-mobile": "false",
                    "image-align": "center",
                    href: "*|PRODUCT_HREF|*",
                    title: "*|PRODUCT_TITLE|*",
                    "raw-title": "*|PRODUCT_TITLE|*",
                    "title-font-size": "17px",
                    "title-color": "#000000",
                    "title-font-family": "Ubuntu, Helvetica, Arial",
                    "title-font-weight": "bold",
                    "title-font-style": "normal",
                    "title-text-transform": "none",
                    "title-text-decoration": "none",
                    "title-align": "center",
                    "title-padding": "15px 10px 0px 10px",
                    description: "*|PRODUCT_DESC|*",
                    "raw-description": "*|PRODUCT_DESC|*",
                    "description-font-size": "14px",
                    "description-color": "#000000",
                    "description-font-family": "Ubuntu, Helvetica, Arial",
                    "description-font-weight": "normal",
                    "description-font-style": "normal",
                    "description-text-transform": "none",
                    "description-text-decoration": "none",
                    "description-align": "center",
                    "description-padding": "10px 10px 5px 10px",
                    "price-before": "*|PRODUCT_PRICE_BEFORE|*",
                    "raw-price-before": "PRODUCT_PRICE_BEFORE",
                    "price-before-font-size": "11px",
                    "price-before-color": "#000000",
                    "price-before-font-family": "Ubuntu, Helvetica, Arial",
                    "price-before-font-weight": "normal",
                    "price-before-font-style": "normal",
                    "price-before-text-transform": "none",
                    "price-before-align": "center",
                    "price-before-padding": "5px 5px 5px 5px",
                    price: "*|PRODUCT_PRICE|*",
                    "raw-price": "*|PRODUCT_PRICE|*",
                    "price-font-size": "18px",
                    "price-color": "#000000",
                    "price-font-family": "Ubuntu, Helvetica, Arial",
                    "price-font-weight": "normal",
                    "price-font-style": "normal",
                    "price-text-transform": "none",
                    "price-text-decoration": "none",
                    "price-align": "center",
                    "price-padding": "10px 10px 10px 10px",
                    "price-suffix": "",
                    "price-prefix": "",
                    layout:
                      "image:show,title:show,description:show,priceBefore:hide,price:show,button:show",
                    dynamic: true,
                    "button-align": "center",
                    "button-border-radius": "3px",
                    "button-padding": "5px 10px 5px 10px",
                    "button-background-color": "#000000",
                    "button-color": "#ffffff",
                    "button-font-size": "13px",
                    "button-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    "button-font-weight": "normal",
                    "button-font-style": "normal",
                    "button-text-transform": "none",
                    "button-text-decoration": "none",
                    "button-inner-padding": "10px 30px 10px 30px",
                    button: "<div>Buy now</div>",
                    containerWidth: 600,
                    "image-padding": "0px 0px 0px 0px",
                  },
                  items: [],
                  mode: "static",
                  layout: "column",
                  maxPerRow: 1,
                  children: [
                    {
                      tagName: "mj-column",
                      uid: "6c0f3bbc-e5bb-49a9-b963-0eb8c38e01e7",
                      attributes: {
                        "vertical-align": "top",
                        padding: "0",
                        width: "100%",
                      },
                      children: [],
                    },
                  ],
                },
              ],
              uid: "Qv2pi1nrCt",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "vYEaOOiQ4A",
        },
      ],
    },
    {
      img: "https://premade-blocks.s3.eu-central-1.amazonaws.com/ecomm4en.png",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 0px 10px 0px",
            "mj-class": "section",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-button",
                  uid: "hLy26wCs4",
                  attributes: {
                    align: "right",
                    "background-color": "#FFFFFF",
                    color: "#000000",
                    "border-radius": "24px",
                    "font-size": "12px",
                    padding: "10px 10px 10px 10px",
                    "inner-padding": "6px 18px",
                    href: "https://google.com",
                    "font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    containerWidth: 200,
                    border: "1px solid #7E7E7E",
                    "line-height": "15px",
                  },
                  content: "<div>Go to the website</div>",
                },
                {
                  tagName: "mj-text",
                  uid: "K8McCQ3e5X",
                  attributes: {
                    align: "left",
                    padding: "0px 10px 5px 10px",
                    "line-height": 1.5,
                    containerWidth: 300,
                  },
                  content: `<h1 style="margin-top: 0px; text-align: center;">Don't miss out on:</h1>`,
                },
                {
                  tagName: "mj-feed-block",
                  uid: "b_06zrO8kS",
                  blockName: "product",
                  attributes: {
                    "columns-layout": "one-column",
                    image: "*|PRODUCT_IMG_SRC|*",
                    "image-width": "300",
                    "image-alt": "",
                    "image-title": "",
                    "image-fluid-on-mobile": "false",
                    "image-align": "center",
                    href: "*|PRODUCT_HREF|*",
                    title: "*|PRODUCT_TITLE|*",
                    "raw-title": "*|PRODUCT_TITLE|*",
                    "title-font-size": "17px",
                    "title-color": "#000000",
                    "title-font-family": "Ubuntu, Helvetica, Arial",
                    "title-font-weight": "bold",
                    "title-font-style": "normal",
                    "title-text-transform": "none",
                    "title-text-decoration": "none",
                    "title-align": "left",
                    "title-padding": "10px 10px 10px 10px",
                    description: "*|PRODUCT_DESC|*",
                    "raw-description": "*|PRODUCT_DESC|*",
                    "description-font-size": "14px",
                    "description-color": "#000000",
                    "description-font-family": "Ubuntu, Helvetica, Arial",
                    "description-font-weight": "normal",
                    "description-font-style": "normal",
                    "description-text-transform": "none",
                    "description-text-decoration": "none",
                    "description-align": "left",
                    "description-padding": "5px 18px 5px 10px",
                    "price-before": "*|PRODUCT_PRICE_BEFORE|*",
                    "raw-price-before": "PRODUCT_PRICE_BEFORE",
                    "price-before-font-size": "11px",
                    "price-before-color": "#000000",
                    "price-before-font-family": "Ubuntu, Helvetica, Arial",
                    "price-before-font-weight": "normal",
                    "price-before-font-style": "normal",
                    "price-before-text-transform": "none",
                    "price-before-align": "center",
                    "price-before-padding": "5px 5px 5px 5px",
                    price: "*|PRODUCT_PRICE|*",
                    "raw-price": "PRODUCT_PRICE",
                    "price-font-size": "18px",
                    "price-color": "#000000",
                    "price-font-family": "Ubuntu, Helvetica, Arial",
                    "price-font-weight": "normal",
                    "price-font-style": "normal",
                    "price-text-transform": "none",
                    "price-text-decoration": "none",
                    "price-align": "center",
                    "price-padding": "0px 18px 5px 10px",
                    "price-suffix": "",
                    "price-prefix": "",
                    layout:
                      "image:show,title:show,description:show,priceBefore:hide,price:show,button:show",
                    dynamic: true,
                    "button-align": "right",
                    "button-border-radius": "3px",
                    "button-padding": "12px 10px 10px 10px",
                    "button-background-color": "#000000",
                    "button-color": "#ffffff",
                    "button-font-size": "13px",
                    "button-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    "button-font-weight": "normal",
                    "button-font-style": "normal",
                    "button-text-transform": "none",
                    "button-text-decoration": "none",
                    "button-inner-padding": "10px 30px 10px 30px",
                    button: "<div>Buy now</div>",
                    containerWidth: 600,
                    "image-padding": "0px 0px 0px 0px",
                  },
                  items: [],
                  mode: "static",
                  layout: "column",
                  maxPerRow: 1,
                  children: [
                    {
                      tagName: "mj-column",
                      uid: "6c0f3bbc-e5bb-49a9-b963-0eb8c38e01e7",
                      attributes: {
                        "vertical-align": "top",
                        padding: "0",
                        width: "100%",
                      },
                      children: [],
                    },
                  ],
                },
              ],
              uid: "Qv2pi1nrCt",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "iowkCocfzh",
        },
      ],
    },
    {
      img: "https://premade-blocks.s3.eu-central-1.amazonaws.com/ecomm5en.png",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 0px 10px 0px",
            "mj-class": "section",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-feed-block",
                  uid: "v-Z_OUrIS",
                  blockName: "product",
                  attributes: {
                    "columns-layout": "one-column",
                    image: "*|PRODUCT_IMG_SRC|*",
                    "image-width": 300,
                    "image-alt": "",
                    "image-title": "",
                    "image-fluid-on-mobile": "false",
                    "image-align": "center",
                    href: "*|PRODUCT_HREF|*",
                    title: "*|PRODUCT_TITLE|*",
                    "raw-title": "*|PRODUCT_TITLE|*",
                    "title-font-size": "17px",
                    "title-color": "#000000",
                    "title-font-family": "Ubuntu, Helvetica, Arial",
                    "title-font-weight": "bold",
                    "title-font-style": "normal",
                    "title-text-transform": "none",
                    "title-text-decoration": "none",
                    "title-align": "center",
                    "title-padding": "0px 10px 0px 10px",
                    description: "*|PRODUCT_DESC|*",
                    "raw-description": "*|PRODUCT_DESC|*",
                    "description-font-size": "14px",
                    "description-color": "#000000",
                    "description-font-family": "Ubuntu, Helvetica, Arial",
                    "description-font-weight": "normal",
                    "description-font-style": "normal",
                    "description-text-transform": "none",
                    "description-text-decoration": "none",
                    "description-align": "center",
                    "description-padding": "5px 10px 5px 10px",
                    "price-before": "*|PRODUCT_PRICE_BEFORE|*",
                    "raw-price-before": "*|PRODUCT_PRICE_BEFORE|*",
                    "price-before-font-size": "11px",
                    "price-before-color": "#000000",
                    "price-before-font-family": "Ubuntu, Helvetica, Arial",
                    "price-before-font-weight": "normal",
                    "price-before-font-style": "normal",
                    "price-before-text-transform": "none",
                    "price-before-align": "center",
                    "price-before-padding": "5px 5px 5px 5px",
                    price: "*|PRODUCT_PRICE|*",
                    "raw-price": "*|PRODUCT_PRICE|*",
                    "price-font-size": "18px",
                    "price-color": "#000000",
                    "price-font-family": "Ubuntu, Helvetica, Arial",
                    "price-font-weight": "normal",
                    "price-font-style": "normal",
                    "price-text-transform": "none",
                    "price-text-decoration": "none",
                    "price-align": "center",
                    "price-padding": "0px 10px 0px 10px",
                    "price-suffix": "",
                    "price-prefix": "",
                    layout:
                      "image:show,title:show,description:show,priceBefore:hide,price:show,button:show",
                    dynamic: true,
                    "button-align": "center",
                    "button-border-radius": "3px",
                    "button-padding": "10px 10px 10px 10px",
                    "button-background-color": "#000000",
                    "button-color": "#ffffff",
                    "button-font-size": "13px",
                    "button-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    "button-font-weight": "normal",
                    "button-font-style": "normal",
                    "button-text-transform": "none",
                    "button-text-decoration": "none",
                    "button-inner-padding": "10px 20px 10px 20px",
                    button: "<div>Buy now</div>",
                    containerWidth: 600,
                    "image-padding": "10px 10px 10px 10px",
                  },
                  items: [],
                  mode: "static",
                  layout: "column",
                  maxPerRow: 2,
                  children: [
                    {
                      tagName: "mj-column",
                      uid: "6c0f3bbc-e5bb-49a9-b963-0eb8c38e01e7",
                      attributes: {
                        "vertical-align": "top",
                        padding: "0",
                        width: "100%",
                      },
                      children: [],
                    },
                  ],
                },
              ],
              uid: "6pvhZ6zASL",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "dgIBlitZ2H",
        },
      ],
    },
    {
      img: "https://premade-blocks.s3.eu-central-1.amazonaws.com/ecomm7en.png",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 0px 10px 0px",
            "mj-class": "section",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "100%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-feed-block",
                  uid: "v-Z_OUrIS",
                  blockName: "product",
                  attributes: {
                    "columns-layout": "one-column",
                    image: "*|PRODUCT_IMG_SRC|*",
                    "image-width": 300,
                    "image-alt": "",
                    "image-title": "",
                    "image-fluid-on-mobile": "false",
                    "image-align": "center",
                    href: "*|PRODUCT_HREF|*",
                    title: "*|PRODUCT_TITLE|*",
                    "raw-title": "*|PRODUCT_TITLE|*",
                    "title-font-size": "17px",
                    "title-color": "#000000",
                    "title-font-family": "Ubuntu, Helvetica, Arial",
                    "title-font-weight": "bold",
                    "title-font-style": "normal",
                    "title-text-transform": "none",
                    "title-text-decoration": "none",
                    "title-align": "center",
                    "title-padding": "0px 10px 0px 10px",
                    description: "*|PRODUCT_DESC|*",
                    "raw-description": "*|PRODUCT_DESC|*",
                    "description-font-size": "14px",
                    "description-color": "#000000",
                    "description-font-family": "Ubuntu, Helvetica, Arial",
                    "description-font-weight": "normal",
                    "description-font-style": "normal",
                    "description-text-transform": "none",
                    "description-text-decoration": "none",
                    "description-align": "center",
                    "description-padding": "5px 10px 5px 10px",
                    "price-before": "*|PRODUCT_PRICE_BEFORE|*",
                    "raw-price-before": "*|PRODUCT_PRICE_BEFORE|*",
                    "price-before-font-size": "11px",
                    "price-before-color": "#000000",
                    "price-before-font-family": "Ubuntu, Helvetica, Arial",
                    "price-before-font-weight": "normal",
                    "price-before-font-style": "normal",
                    "price-before-text-transform": "none",
                    "price-before-align": "center",
                    "price-before-padding": "5px 5px 5px 5px",
                    price: "*|PRODUCT_PRICE|*",
                    "raw-price": "*|PRODUCT_PRICE|*",
                    "price-font-size": "18px",
                    "price-color": "#000000",
                    "price-font-family": "Ubuntu, Helvetica, Arial",
                    "price-font-weight": "normal",
                    "price-font-style": "normal",
                    "price-text-transform": "none",
                    "price-text-decoration": "none",
                    "price-align": "center",
                    "price-padding": "0px 10px 0px 10px",
                    "price-suffix": "",
                    "price-prefix": "",
                    layout:
                      "image:show,title:show,description:show,priceBefore:hide,price:show,button:show",
                    dynamic: true,
                    "button-align": "center",
                    "button-border-radius": "3px",
                    "button-padding": "10px 10px 10px 10px",
                    "button-background-color": "#000000",
                    "button-color": "#ffffff",
                    "button-font-size": "13px",
                    "button-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    "button-font-weight": "normal",
                    "button-font-style": "normal",
                    "button-text-transform": "none",
                    "button-text-decoration": "none",
                    "button-inner-padding": "10px 20px 10px 20px",
                    button: "<div>Buy now</div>",
                    containerWidth: 600,
                    "image-padding": "10px 10px 10px 10px",
                  },
                  items: [],
                  mode: "static",
                  layout: "column",
                  maxPerRow: 3,
                  children: [
                    {
                      tagName: "mj-column",
                      uid: "6c0f3bbc-e5bb-49a9-b963-0eb8c38e01e7",
                      attributes: {
                        "vertical-align": "top",
                        padding: "0",
                        width: "100%",
                      },
                      children: [],
                    },
                  ],
                },
              ],
              uid: "6pvhZ6zASL",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "dgIBlitZ2H",
        },
      ],
    },
    {
      img: "https://premade-blocks.s3.eu-central-1.amazonaws.com/ecomm8en.png",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "10px 0px 10px 0px",
            "mj-class": "section",
          },
          children: [
            {
              tagName: "mj-column",
              attributes: { width: "100%", "vertical-align": "top" },
              children: [
                {
                  tagName: "mj-feed-block",
                  uid: "v-Z_OUrIS",
                  blockName: "product",
                  attributes: {
                    "columns-layout": "one-column",
                    image: "*|PRODUCT_IMG_SRC|*",
                    "image-width": 300,
                    "image-alt": "",
                    "image-title": "",
                    "image-fluid-on-mobile": "false",
                    "image-align": "center",
                    href: "*|PRODUCT_HREF|*",
                    title: "*|PRODUCT_TITLE|*",
                    "raw-title": "*|PRODUCT_TITLE|*",
                    "title-font-size": "15px",
                    "title-color": "#000000",
                    "title-font-family": "Ubuntu, Helvetica, Arial",
                    "title-font-weight": "bold",
                    "title-font-style": "normal",
                    "title-text-transform": "none",
                    "title-text-decoration": "none",
                    "title-align": "center",
                    "title-padding": "0px 10px 0px 10px",
                    description: "*|PRODUCT_DESC|*",
                    "raw-description": "*|PRODUCT_DESC|*",
                    "description-font-size": "14px",
                    "description-color": "#000000",
                    "description-font-family": "Ubuntu, Helvetica, Arial",
                    "description-font-weight": "normal",
                    "description-font-style": "normal",
                    "description-text-transform": "none",
                    "description-text-decoration": "none",
                    "description-align": "center",
                    "description-padding": "5px 10px 5px 10px",
                    "price-before": "*|PRODUCT_PRICE_BEFORE|*",
                    "raw-price-before": "*|PRODUCT_PRICE_BEFORE|*",
                    "price-before-font-size": "11px",
                    "price-before-color": "#000000",
                    "price-before-font-family": "Ubuntu, Helvetica, Arial",
                    "price-before-font-weight": "normal",
                    "price-before-font-style": "normal",
                    "price-before-text-transform": "none",
                    "price-before-align": "center",
                    "price-before-padding": "5px 5px 5px 5px",
                    price: "*|PRODUCT_PRICE|*",
                    "raw-price": "*|PRODUCT_PRICE|*",
                    "price-font-size": "16px",
                    "price-color": "#000000",
                    "price-font-family": "Ubuntu, Helvetica, Arial",
                    "price-font-weight": "normal",
                    "price-font-style": "normal",
                    "price-text-transform": "none",
                    "price-text-decoration": "none",
                    "price-align": "center",
                    "price-padding": "0px 10px 0px 10px",
                    "price-suffix": "",
                    "price-prefix": "",
                    layout:
                      "image:show,title:show,description:show,priceBefore:hide,price:show,button:show",
                    dynamic: true,
                    "button-align": "center",
                    "button-border-radius": "3px",
                    "button-padding": "10px 10px 10px 10px",
                    "button-background-color": "#000000",
                    "button-color": "#ffffff",
                    "button-font-size": "13px",
                    "button-font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    "button-font-weight": "normal",
                    "button-font-style": "normal",
                    "button-text-transform": "none",
                    "button-text-decoration": "none",
                    "button-inner-padding": "10px 20px 10px 20px",
                    button: "<div>Buy now</div>",
                    containerWidth: 600,
                    "image-padding": "10px 10px 10px 10px",
                  },
                  items: [],
                  mode: "static",
                  layout: "column",
                  maxPerRow: 4,
                  children: [
                    {
                      tagName: "mj-column",
                      uid: "6c0f3bbc-e5bb-49a9-b963-0eb8c38e01e7",
                      attributes: {
                        "vertical-align": "top",
                        padding: "0",
                        width: "100%",
                      },
                      children: [],
                    },
                  ],
                },
              ],
              uid: "6pvhZ6zASL",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "dgIBlitZ2H",
        },
      ],
    },
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/ecomm/ecomm6.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "24px 0px 24px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 30px 0px 0px",
                    containerWidth: 300,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                  },
                  uid: "rkXEXP8gm",
                  content:
                    '<h2 style="margin-top: 0px">Milumia</h2>\n\n<p><span style="color:#999999;"><span style="font-size:14px;">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aliquam ante. Quis autem vel eum iure reprehenderit</span></span></p>\n\n<p><span style="font-size:18px;">$30</span></p>\n',
                },
                {
                  tagName: "mj-button",
                  attributes: {
                    align: "left",
                    "background-color": "#207DE7",
                    color: "#FFFFFF",
                    "border-radius": "8px",
                    "font-size": "13px",
                    padding: "11px 0px 0px 0px",
                    "inner-padding": "9px 26px",
                    href: "https://google.com",
                    "font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    containerWidth: 300,
                    border: "0px solid #000",
                  },
                  content: "Shop now",
                  uid: "HJxqmw8em",
                },
              ],
              uid: "By-4xCDIx7",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/51p0p1TDGnL._AC_UL500_SR385,500_FMwebp_QL65_.jpg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 300,
                    width: 138,
                    widthPercent: 46,
                  },
                  uid: "xJXgQP8xX",
                },
              ],
              uid: "HJMVRRwLgx",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "H1IymwIxx",
        },
      ],
    },
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/ecomm/ecomm5.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "24px 0px 24px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-image",
                  attributes: {
                    src: "https://storage.googleapis.com/jan50/51p0p1TDGnL._AC_UL500_SR385,500_FMwebp_QL65_.jpg",
                    padding: "0px 0px 0px 0px",
                    alt: "",
                    href: "",
                    containerWidth: 300,
                    width: 138,
                    widthPercent: 46,
                  },
                  uid: "xJXgQP8xX",
                },
              ],
              uid: "HJMVRRwLgx",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 30px 0px 0px",
                    containerWidth: 300,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                  },
                  uid: "rkXEXP8gm",
                  content:
                    '<h2 style="margin-top: 0px">Milumia</h2>\n\n<p><span style="color:#999999;"><span style="font-size:14px;">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aliquam ante. Quis autem vel eum iure reprehenderit</span></span></p>\n\n<p><span style="font-size:18px;">$30</span></p>\n',
                },
                {
                  tagName: "mj-button",
                  attributes: {
                    align: "left",
                    "background-color": "#207DE7",
                    color: "#FFFFFF",
                    "border-radius": "8px",
                    "font-size": "13px",
                    padding: "11px 0px 0px 0px",
                    "inner-padding": "9px 26px",
                    href: "https://google.com",
                    "font-family":
                      "Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif",
                    containerWidth: 300,
                    border: "0px solid #000",
                  },
                  content: "Shop now",
                  uid: "HJxqmw8em",
                },
              ],
              uid: "By-4xCDIx7",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "H1IymwIxx",
        },
      ],
    },
  ],
  footers: [
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/footers/footer2.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "0px 0px 0px 0px",
            "background-color": "#222222",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-spacer",
                  attributes: {
                    height: 30,
                    containerWidth: 300,
                  },
                  uid: "ryx8H8gVlX",
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 30px 0px 30px",
                    color: "#FFFFFF",
                    containerWidth: 300,
                  },
                  uid: "HJWLrLl4em",
                  content:
                    '<p><span style="font-size:16px;">Follow us</span></p>\n\n<p><span style="color:#999999;"><span style="font-size:14px;">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aliquam ante. Quis autem vel eum iure reprehenderit</span></span></p>\n',
                },
                {
                  tagName: "mj-social",
                  attributes: {
                    "text-mode": "false",
                    "icon-size": "35px",
                    align: "left",
                    containerWidth: 300,
                    padding: "0px 0px 15px 25px",
                  },
                  children: [
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.facebook.com/PROFILE",
                        name: "Facebook",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/simplegrey/facebook.png",
                      },
                      tagName: "mj-social-element",
                    },
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.twitter.com/PROFILE",
                        name: "Twitter",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/simplegrey/twitter.png",
                      },
                      tagName: "mj-social-element",
                    },
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.instagram.com/PROFILE",
                        name: "Instagram",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/simplegrey/instagram.png",
                      },
                      tagName: "mj-social-element",
                    },
                  ],
                  uid: "HJGIHLxVeQ",
                },
              ],
              uid: "SJ5r-g4eQ",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-spacer",
                  attributes: {
                    height: 30,
                    containerWidth: 300,
                  },
                  uid: "H1XISUl4g7",
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 30px 0px 30px",
                    color: "#FFFFFF",
                    containerWidth: 300,
                  },
                  uid: "H1ELS8gVgQ",
                  content:
                    '<p><span style="font-size:16px;">Contact us</span></p>\n\n<p><span style="color:#999999;"><span style="font-size:14px;">16 Homewood Lane&nbsp;<br />\nFitchburg, MA 01420</span></span></p>\n',
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 30px 0px 30px",
                    color: "#FFFFFF",
                    containerWidth: 300,
                  },
                  uid: "r1S8HIl4eX",
                  content:
                    '<p><span style="font-size:16px;">202-555-0173</span></p>\n\n<p><a href="mailto:foo@bar.cz" style="color:#3498db;font-size: 14px;">foo@bar.cz</a></p>\n',
                },
              ],
              uid: "SJ5r-g4eQ",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "S1USUlVgm",
        },
      ],
    },
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/footers/footer3.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "0px 0px 0px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-spacer",
                  attributes: {
                    height: 30,
                    containerWidth: 300,
                  },
                  uid: "HygHQSe4eQ",
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 30px 0px 30px",
                    color: "#0A0A0A",
                    containerWidth: 300,
                  },
                  uid: "Skg2Be4em",
                  content:
                    '<p><span style="font-size:16px;">Follow us</span></p>\n\n<p><span style="color:#999999;"><span style="font-size:14px;">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aliquam ante. Quis autem vel eum iure reprehenderit</span></span></p>\n',
                },
                {
                  tagName: "mj-social",
                  attributes: {
                    "text-mode": "false",
                    "icon-size": "35px",
                    align: "left",
                    containerWidth: 300,
                    padding: "0px 0px 15px 25px",
                  },
                  children: [
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.facebook.com/PROFILE",
                        name: "Facebook",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/facebook.png",
                      },
                      tagName: "mj-social-element",
                    },
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.twitter.com/PROFILE",
                        name: "Twitter",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/twitter.png",
                      },
                      tagName: "mj-social-element",
                    },
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.instagram.com/PROFILE",
                        name: "Instagram",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/instagram.png",
                      },
                      tagName: "mj-social-element",
                    },
                  ],
                  uid: "S1bS7HxVgm",
                },
              ],
              uid: "SJ5r-g4eQ",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-spacer",
                  attributes: {
                    height: 30,
                    containerWidth: 300,
                  },
                  uid: "rk1VHxNgm",
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 30px 0px 30px",
                    color: "#000000",
                    containerWidth: 300,
                  },
                  uid: "S1y1LxNe7",
                  content:
                    '<p><span style="font-size:16px;">Contact us</span></p>\n\n<p><span style="color:#999999;"><span style="font-size:14px;">16 Homewood Lane&nbsp;<br />\nFitchburg, MA 01420</span></span></p>\n',
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 30px 0px 30px",
                    color: "#000000",
                    containerWidth: 300,
                  },
                  uid: "S1f2rgNxm",
                  content:
                    '<p><span style="font-size:16px;">202-555-0173</span></p>\n\n<p><a href="mailto:foo@bar.cz" style="color:#3498db;font-size: 14px;">foo@bar.cz</a></p>\n',
                },
              ],
              uid: "SJ5r-g4eQ",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "BJBXSlVxX",
        },
      ],
    },
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/footers/footer4.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "0px 0px 0px 0px",
            "background-color": "#222222",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "100%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-spacer",
                  attributes: {
                    height: 30,
                    containerWidth: 600,
                  },
                  uid: "SygkZHeNe7",
                },
                {
                  tagName: "mj-social",
                  attributes: {
                    "text-mode": "false",
                    "icon-size": "35px",
                    align: "center",
                    containerWidth: 600,
                    padding: "5px 5px 5px 5px",
                  },
                  children: [
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.facebook.com/PROFILE",
                        name: "Facebook",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/facebook.png",
                      },
                      tagName: "mj-social-element",
                    },
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.twitter.com/PROFILE",
                        name: "Twitter",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/twitter.png",
                      },
                      tagName: "mj-social-element",
                    },
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.instagram.com/PROFILE",
                        name: "Instagram",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/instagram.png",
                      },
                      tagName: "mj-social-element",
                    },
                  ],
                  uid: "rkWJZrlVeQ",
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "0px 35px 0px 35px",
                    color: "#D8D8D8",
                    containerWidth: 600,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                  },
                  uid: "rkGJZBx4eX",
                  content:
                    '<p><span style="font-size:14px;">16 Homewood Lane&nbsp;<br />\nFitchburg, MA 01420</span></p>\n',
                },
              ],
              uid: "SJ5r-g4eQ",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "ryybBg4lX",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "0px 0px 0px 0px",
            "background-color": "#222222",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "100%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "0px 35px 10px 35px",
                    color: "#FFFFFF",
                    containerWidth: 300,
                  },
                  uid: "SJlQWSx4l7",
                  content:
                    '<p><span style="font-size:12px;"><a href="*|PREFERENCES|*" style="color:#3498db;">Newsletter preferences</a>&nbsp; &nbsp;&nbsp;&nbsp;<a href="*|UNSUB|*" style="color:#3498db;">Unsubscribe</a></span></p>\n',
                },
              ],
              uid: "S1W4Vg4gQ",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "S1X-BgNgm",
        },
      ],
    },
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/footers/footer5.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "0px 0px 0px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "100%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-spacer",
                  attributes: {
                    height: 30,
                    containerWidth: 600,
                  },
                  uid: "BkwgSlEl7",
                },
                {
                  tagName: "mj-social",
                  attributes: {
                    "text-mode": "false",
                    "icon-size": "35px",
                    align: "center",
                    containerWidth: 600,
                    padding: "5px 5px 5px 5px",
                  },
                  children: [
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.facebook.com/PROFILE",
                        name: "Facebook",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/facebook.png",
                      },
                      tagName: "mj-social-element",
                    },
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.twitter.com/PROFILE",
                        name: "Twitter",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/twitter.png",
                      },
                      tagName: "mj-social-element",
                    },
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.instagram.com/PROFILE",
                        name: "Instagram",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/instagram.png",
                      },
                      tagName: "mj-social-element",
                    },
                  ],
                  uid: "rJ-yHeVg7",
                },
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "0px 35px 0px 35px",
                    color: "#222222",
                    containerWidth: 600,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                  },
                  uid: "Byl50EeEeX",
                  content:
                    '<p><span style="font-size:14px;">16 Homewood Lane&nbsp;<br />\nFitchburg, MA 01420</span></p>\n',
                },
              ],
              uid: "SJ5r-g4eQ",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "r190ElNl7",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "0px 0px 0px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "100%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "0px 35px 10px 35px",
                    color: "#FFFFFF",
                    containerWidth: 300,
                  },
                  uid: "BkejySe4xQ",
                  content:
                    '<p><span style="font-size:12px;"><a href="*|PREFERENCES|*" style="color:#3498db;">Newsletter preferences</a>&nbsp; &nbsp;&nbsp;&nbsp;<a href="*|UNSUB|*" style="color:#3498db;">Unsubscribe</a></span></p>\n',
                },
              ],
              uid: "S1W4Vg4gQ",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "rJi1BlVgX",
        },
      ],
    },
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/footers/footer6.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "21px 0px 21px 0px",
            "background-color": "#222222",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 35px 0px 35px",
                    color: "#D8D8D8",
                    containerWidth: 300,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                  },
                  uid: "H1g7ezgVeX",
                  content:
                    '<p><span style="font-size:14px;">16 Homewood Lane&nbsp;<br />\nFitchburg, MA 01420</span></p>\n',
                },
              ],
              uid: "SJ5r-g4eQ",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-social",
                  attributes: {
                    "text-mode": "false",
                    "icon-size": "35px",
                    align: "right",
                    containerWidth: 300,
                    padding: "0px 20px 0px 0px",
                  },
                  children: [
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.facebook.com/PROFILE",
                        name: "Facebook",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/facebook.png",
                      },
                      tagName: "mj-social-element",
                    },
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.twitter.com/PROFILE",
                        name: "Twitter",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/twitter.png",
                      },
                      tagName: "mj-social-element",
                    },
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.instagram.com/PROFILE",
                        name: "Instagram",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/instagram.png",
                      },
                      tagName: "mj-social-element",
                    },
                  ],
                  uid: "Sy-mlMlExQ",
                },
              ],
              uid: "BygcS-lNgX",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "HJXlflVem",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "0px 0px 0px 0px",
            "background-color": "#222222",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "100%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "0px 35px 10px 35px",
                    color: "#FFFFFF",
                    containerWidth: 300,
                  },
                  uid: "BkxsxzxNgQ",
                  content:
                    '<p><span style="font-size:12px;"><a href="*|PREFERENCES|*" style="color:#3498db;">Newsletter preferences</a>&nbsp; &nbsp;&nbsp;&nbsp;<a href="*|UNSUB|*" style="color:#3498db;">Unsubscribe</a></span></p>\n',
                },
              ],
              uid: "S1W4Vg4gQ",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "rkiezlVem",
        },
      ],
    },
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/footers/footer7.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "21px 0px 21px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 35px 0px 35px",
                    color: "#1D1D1D",
                    containerWidth: 300,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                  },
                  uid: "rJgDlfg4xX",
                  content:
                    '<p><span style="font-size:14px;">16 Homewood Lane&nbsp;<br />\nFitchburg, MA 01420</span></p>\n',
                },
              ],
              uid: "SJ5r-g4eQ",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-social",
                  attributes: {
                    "text-mode": "false",
                    "icon-size": "35px",
                    align: "right",
                    containerWidth: 300,
                    padding: "0px 20px 0px 0px",
                  },
                  children: [
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.facebook.com/PROFILE",
                        name: "Facebook",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/facebook.png",
                      },
                      tagName: "mj-social-element",
                    },
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.twitter.com/PROFILE",
                        name: "Twitter",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/twitter.png",
                      },
                      tagName: "mj-social-element",
                    },
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.instagram.com/PROFILE",
                        name: "Instagram",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/instagram.png",
                      },
                      tagName: "mj-social-element",
                    },
                  ],
                  uid: "S1WDgGlNgX",
                },
              ],
              uid: "BygcS-lNgX",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "HyvxfgNeX",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "0px 0px 0px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "100%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "center",
                    "font-size": "11px",
                    padding: "0px 35px 10px 35px",
                    color: "#FFFFFF",
                    containerWidth: 300,
                  },
                  uid: "BJ0j-xVlm",
                  content:
                    '<p><span style="font-size:12px;"><a href="*|PREFERENCES|*" style="color:#3498db;">Newsletter preferences</a>&nbsp; &nbsp;&nbsp;&nbsp;<a href="*|UNSUB|*" style="color:#3498db;">Unsubscribe</a></span></p>\n',
                },
              ],
              uid: "rJebNEeEeX",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "HJii-gVxQ",
        },
      ],
    },
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/footers/footer8.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "21px 0px 21px 0px",
            "background-color": "#222222",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 35px 0px 35px",
                    color: "#D8D8D8",
                    containerWidth: 300,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                  },
                  uid: "rJg_kWxVgm",
                  content:
                    '<p><span style="font-size:14px;">16 Homewood Lane&nbsp;<br />\nFitchburg, MA 01420</span></p>\n',
                },
              ],
              uid: "SJ5r-g4eQ",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-social",
                  attributes: {
                    "text-mode": "false",
                    "icon-size": "35px",
                    align: "right",
                    containerWidth: 300,
                    padding: "0px 20px 0px 0px",
                  },
                  children: [
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.facebook.com/PROFILE",
                        name: "Facebook",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/facebook.png",
                      },
                      tagName: "mj-social-element",
                    },
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.twitter.com/PROFILE",
                        name: "Twitter",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/twitter.png",
                      },
                      tagName: "mj-social-element",
                    },
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.instagram.com/PROFILE",
                        name: "Instagram",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/instagram.png",
                      },
                      tagName: "mj-social-element",
                    },
                  ],
                  uid: "rJMu1WxVgm",
                },
              ],
              uid: "BygcS-lNgX",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "rydkWxVg7",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "0px 0px 0px 0px",
            "background-color": "#222222",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "100%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 35px 10px 35px",
                    color: "#FFFFFF",
                    containerWidth: 300,
                  },
                  uid: "B1l3KNxNgQ",
                  content:
                    '<p><span style="font-size:12px;"><a href="*|UNSUB|*" style="color:#3498db;">Unsubscribe</a>&nbsp;or&nbsp;<br />\n<a href="*|PREFERENCES|*" style="color:#3498db;">Change your preferences</a></span></p>\n',
                },
              ],
              uid: "B1bb4NxExX",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "r1htNlNgX",
        },
      ],
    },
    {
      img: "https://d5aoblv5p04cg.cloudfront.net/editor-3/assets/images/en-premade/footers/footer9.jpg",
      definition: [
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "21px 0px 21px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 35px 0px 35px",
                    color: "#1B1B1B",
                    containerWidth: 300,
                    "font-family": 'Lato, "Tahoma", sans-serif',
                  },
                  uid: "HkbkCFpJQ",
                  content:
                    '<p><span style="font-size:14px;">16 Homewood Lane&nbsp;<br />\nFitchburg, MA 01420</span></p>\n',
                },
              ],
              uid: "r1W5BWlNgm",
            },
            {
              tagName: "mj-column",
              attributes: {
                width: "50%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-social",
                  attributes: {
                    "text-mode": "false",
                    "icon-size": "35px",
                    align: "right",
                    containerWidth: 300,
                    padding: "0px 20px 0px 0px",
                  },
                  children: [
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.facebook.com/PROFILE",
                        name: "Facebook",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/facebook.png",
                      },
                      tagName: "mj-social-element",
                    },
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.twitter.com/PROFILE",
                        name: "Twitter",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/twitter.png",
                      },
                      tagName: "mj-social-element",
                    },
                    {
                      attributes: {
                        "background-color": "transparent",
                        href: "https://www.instagram.com/PROFILE",
                        name: "Instagram",
                        src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlinedbw/instagram.png",
                      },
                      tagName: "mj-social-element",
                    },
                  ],
                  uid: "S1eQAYa1Q",
                },
              ],
              uid: "Syz5r-gElm",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "r1zhxe4eX",
        },
        {
          tagName: "mj-section",
          attributes: {
            "full-width": false,
            padding: "0px 0px 0px 0px",
            "background-color": "#FFFFFF",
          },
          type: null,
          children: [
            {
              tagName: "mj-column",
              attributes: {
                width: "100%",
                "vertical-align": "top",
              },
              children: [
                {
                  tagName: "mj-text",
                  attributes: {
                    align: "left",
                    "font-size": "11px",
                    padding: "0px 35px 10px 35px",
                    color: "#1D1D1D",
                    containerWidth: 300,
                  },
                  uid: "BJi5flNeX",
                  content:
                    '<p><span style="font-size:12px;"><a draggable="false" href="*|UNSUB|*" style="color:#3498db;">Unsubscribe</a> or<br />\n<a draggable="false" href="*|UNSUB|*" style="color:#3498db;">Change your preferences</a></span></p>\n',
                },
              ],
              uid: "B1bb4NxExX",
            },
          ],
          layout: 1,
          backgroundColor: "",
          backgroundImage: "",
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          uid: "SyKczgNeQ",
        },
      ],
    },
  ],
} as ILegacyPremadeBlocks;
